import PropTypes from 'prop-types'
import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { Link, useLocation } from 'react-router-dom'

import { otpLoginSelector } from 'reduxModules/auth/selectors'
import { otpLoginDispatchers } from 'reduxModules/auth/dispatchers'
import { OtpEntry } from '../../generic/OtpEntry'
import '../styles.css'
import './styles.css'

// The password alternative goes back to wherever the flow started.
const returnPath = (flow) => {
  if (flow.inCheckout && flow.next) return flow.next
  return flow.trigger === 'register' ? '/users/signup' : '/login'
}

/**
 * /login/otp — one-time code login (SPEC-041). The flow (email, trigger,
 * return path) arrives through route state (see utils/otpRoute), which
 * survives a refresh but not a shared link; without it the page simply asks
 * for the email.
 */
export function OtpLogin({
  recaptcha,
  sendOtp,
  verifyCode,
  hideGlobalNav,
  showGlobalNav
}) {
  const { state } = useLocation()
  const flow = state || {}

  useEffect(() => {
    hideGlobalNav()
    return () => showGlobalNav()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div id="OtpLogin" className="auth-page">
      <div>
        <header className="logo">
          <Link to="/">
            <img src="/global/assets/images/logo/logo-big.png" alt="Stan Winston School Of Character Arts" />
          </Link>
        </header>
        <OtpEntry
          email={flow.email || ''}
          recaptcha={recaptcha}
          sendOtp={sendOtp}
          verifyCode={(email, code) => verifyCode({ ...flow, email }, code)}
        >
          <div className="auth-alt">
            or <Link to={returnPath(flow)}>Log in with a password</Link>
          </div>
        </OtpEntry>
      </div>
    </div>
  )
}

OtpLogin.propTypes = {
  recaptcha: PropTypes.shape({
    token: PropTypes.string,
    version: PropTypes.string
  }),
  sendOtp: PropTypes.func.isRequired,
  verifyCode: PropTypes.func.isRequired,
  hideGlobalNav: PropTypes.func.isRequired,
  showGlobalNav: PropTypes.func.isRequired
}

export default connect(otpLoginSelector, null, otpLoginDispatchers)(OtpLogin)
